import styles from "./CartButton.module.css"
import { ShoppingCart } from 'lucide-react';
/**
* Props for the CartButton component.
*/ 
interface CartButtonProps{
    onClick: ()=>void, // Click event handler
    indicatorText?:string // Text over the button
}
/**
* A small cart button. Used in header.
*
* @param props CartButton props
* @param {() => void} props.onClick - Function to call on click.
* @param {string} props.indicatorText - Text over the button
* @returns TSX.Element
*/
const CartButton = ({onClick, indicatorText}: CartButtonProps) => {
    
    return (
        <>
            <button className={styles.CartButton} onClick={onClick}>
                <div className={styles.CartIndicator}>
                    <p>{indicatorText}</p>
                </div>
                <ShoppingCart />
            </button>
        </>
    )
};

export default CartButton;